import * as React from 'react';
import { useGridRegisterPreProcessor } from '../../core/preProcessing';
export const useGridRegisterFilteringMethod = (apiRef, groupingName, filteringMethod) => {
  const updateRegistration = React.useCallback(filteringMethodCollection => {
    filteringMethodCollection[groupingName] = filteringMethod;
    return filteringMethodCollection;
  }, [groupingName, filteringMethod]);
  useGridRegisterPreProcessor(apiRef, 'filteringMethod', updateRegistration);
};